import { ChatPipe } from './components/chatroom/chatfilter.pipe';
import { SearchPipe } from './components/chatroom/search.pipe';
import { DashboardContainer } from './dashboard.container';
import { DashboardService } from './../../core/services/dashboard.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './../../shared/components/shared.module';
import { ChatroomComponent } from './components/chatroom/chatroom.component';
import { SettingsComponent } from './components/settings/settings.component';
import { BookingsComponent } from './components/bookings/bookings.component';
import { RequestComponent } from './shared/request/request.component';
import { BookingComponent } from './shared/booking/booking.component';
import { RequestsComponent } from './components/requests/requests.component';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { DashboardComponent } from './dashboard.component';
import { AuthGuard } from '../../core/guards/auth-guard';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DashboardInitComponent } from './dashboard-init.component';
import { NgxSpinnerModule } from 'ngx-spinner';
const routes: Routes = [
    {
        path: 'my-dashboard', component: DashboardInitComponent, canActivate: [AuthGuard], children: [
            { path: 'my-requests', component: RequestsComponent, canActivate: [AuthGuard] },
            { path: 'my-requests/:vvm', component: RequestsComponent, canActivate: [AuthGuard] },
            { path: 'my-bookings', component: BookingsComponent, canActivate: [AuthGuard] },
            { path: 'my-settings', component: SettingsComponent, canActivate: [AuthGuard] },
            { path: 'messages', component: ChatroomComponent, canActivate: [AuthGuard] },
            { path: '', component: DashboardComponent, canActivate: [AuthGuard], pathMatch: 'full' }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes),
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
        NgbModule,
        SweetAlert2Module,
        NgxSpinnerModule
    ],
    exports: [RouterModule],
    declarations: [
        DashboardComponent,
        RequestsComponent,
        RequestComponent,
        BookingComponent,
        BookingsComponent,
        SettingsComponent,
        ChatroomComponent,
        SearchPipe,
        ChatPipe,
        DashboardInitComponent

    ],
    providers: [
        AuthGuard,
        DashboardService,
        DashboardContainer
    ],

})
export class DashboardModule { }
